const adretailTranslate = {
  RUT: "RUT",
  Criteria0: "Región",
  Criteria1: "Comuna",
  Criteria2: "Localidad",
}

export default adretailTranslate
